// removed by extract-text-webpack-plugin
module.exports = {"borderGray":"#d9d9d9","title":"title-3Pxrp","dumbbell":"dumbbell-2TGi2","description":"description-2Cux_","workoutForm":"workoutForm-RrQ_u","loadingModal":"loadingModal-3jdpd","loadingTitle":"loadingTitle-2zcjn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/workouts/create/_logWorkoutPage.css
// module id = 1286
// module chunks = 1